// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3D7-2","link":"styles_link__YklJC"};